import { render, staticRenderFns } from "./DarkDownload.vue?vue&type=template&id=7b9b03d8&scoped=true&"
import script from "./DarkDownload.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkDownload.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DarkDownload.vue?vue&type=style&index=0&id=7b9b03d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b03d8",
  null
  
)

export default component.exports